// 简单的http请求，当前用于请求备用域名信息
function _httpRequest(url, method) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open(method, url)
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.responseText)
        } else {
          reject(new Error(`Request failed with status ${xhr.status}`))
        }
      }
    }
    xhr.onerror = () => {
      reject(new Error('Request failed'))
    }
    xhr.send()
  })
}

// 切换域名逻辑配置
class ChangeHostConfig {
  // 主域名，默认域名
  static defaultHost = 'https://api.winbull8.com'
  // 请求备用域名文件链接
  static backupReqUrl = 'https://prod-winbull-config.oss-cn-hongkong.aliyuncs.com/bakcup.txt'
  // 请求备用域名返回JSON数据的字段
  static backupJsonField = 'urls'
  // 备用域名本地存储key
  static backupLocalKey = 'BackupHostInfo'
  // 接口错误次数本地存款key
  static hostErrLocalKey = 'HostErrCount'
  // 备用域名信息本地存储超时时限
  static backupLocalLimit = 10 * 60 * 1000
  // 接口非服务器异常次数限制
  static reqHostErrLimit = 2
  // 记录上一次是否使用备用域名本地存储key
  static isUseBackupHostKey = 'IsUseBackupHost'

  static initConfig(config) {
    if (config) {
      if (config.defaultHost) {
        this.defaultHost = config.defaultHost
      }
      if (config.backupReqUrl) {
        this.backupReqUrl = config.backupReqUrl
      }
      if (config.backupJsonField) {
        this.backupJsonField = config.backupJsonField
      }
      if (config.backupLocalKey) {
        this.backupLocalKey = config.backupLocalKey
      }
      if (config.hostErrLocalKey) {
        this.hostErrLocalKey = config.hostErrLocalKey
      }
      if (config.backupLocalLimit) {
        this.backupLocalLimit = config.backupLocalLimit
      }
      if (config.reqHostErrLimit) {
        this.reqHostErrLimit = config.reqHostErrLimit
      }
      if (config.isUseBackupHostKey) {
        this.isUseBackupHostKey = config.isUseBackupHostKey
      }
    }
  }
}

// 备用域名管理
class BackupHostManage {
  // 备用域名列表
  static _hostList = []
  // 记录时间（存储时间）
  static _recordTime = 0

  static get hostList() {
    // 确保在多个页面同时打开时，拿的都是同步的
    this.getData()
    return this._hostList
  }
  static get recordTime() {
    // 确保在多个页面同时打开时，拿的都是同步的
    this.getData()
    return this._recordTime
  }

  // 获取当前host
  static get currentHost() {
    if (this.hostList.length === 0) {
      return ''
    } else {
      return this.hostList[0]
    }
  }

  // 备用域名是否为空
  static get isHostListEmpty() {
    return this.hostList.length === 0
  }

  // 记录时间是否超过时间
  static get isRecordTimeOut() {
    return new Date().getTime() - (this.recordTime || 0) > ChangeHostConfig.backupLocalLimit
  }

  // 获取备用域名数据(本地)
  static getData() {
    const localData = localStorage.getItem(ChangeHostConfig.backupLocalKey)
    if (localData) {
      const resData = JSON.parse(localData)
      const { hostList, recordTime } = resData
      this._hostList = hostList
      this._recordTime = recordTime
    }
  }

  // 保存备用域名数据(本地)
  static recordData() {
    const currentData = {
      hostList: this._hostList,
      recordTime: new Date().getTime()
    }
    localStorage.setItem(ChangeHostConfig.backupLocalKey, JSON.stringify(currentData))
  }

  // 清除备用域名信息
  static cleanData() {
    localStorage.removeItem(ChangeHostConfig.backupLocalKey)
  }

  // 请求备用域名信息
  static async reqData() {
    try {
      const res = await _httpRequest(ChangeHostConfig.backupReqUrl, 'GET')
      if (res) {
        const hosts = JSON.parse(res)[ChangeHostConfig.backupJsonField]
        if (hosts && hosts.length > 0) {
          let index = hosts.indexOf(ChangeHostConfig.defaultHost)
          while (index > -1) {
            hosts.splice(index, 1)
            index = hosts.indexOf(ChangeHostConfig.defaultHost)
          }
          this._hostList = hosts
        } else {
          this._hostList = []
        }
        this.recordData()
        // console.log(this.hostList)
      }
    } catch (_) {
      // eslint-disable-next-line no-empty
    }
  }

  // 切换下一个域名
  static changeNext() {
    const hostList = this.hostList
    // list移除当前备用域名（index==0）
    hostList.splice(0, 1)
    this.recordData()
  }
}

// 域名请求异常（非服务器异常）管理
class HostErrManage {
  // 异常次数
  static get errCount() {
    const count = sessionStorage.getItem(ChangeHostConfig.hostErrLocalKey)
    if (count) {
      return JSON.parse(count) || 0
    } else {
      return 0
    }
  }

  // 是否异常次数超过限制次数
  static get isErrCountOut() {
    return this.errCount >= ChangeHostConfig.reqHostErrLimit
  }

  // 清除异常次数
  static cleanCount() {
    sessionStorage.removeItem(ChangeHostConfig.hostErrLocalKey)
  }

  // 累加异常次数
  static addCount() {
    let count = this.errCount
    count++
    sessionStorage.setItem(ChangeHostConfig.hostErrLocalKey, JSON.stringify(count))
  }

  // 处理响应体
  static handleRes(res, limitHandle) {
    console.log(res)
    // 响应体不存在
    // 响应体的status不存在
    if (!res || !res.status) {
      this.addCount()
      if (this.isErrCountOut && limitHandle) {
        limitHandle()
      }
    }
    if (res && res.status) {
      this.cleanCount()
    }
  }

  // 处理响应异常
  static handleErr(err, limitHandle) {
    // err不存在
    // err的status不存在
    if (!err || !err.status) {
      this.addCount()
      if (this.isErrCountOut && limitHandle) {
        limitHandle()
      }
    }
  }
}

class ChangeHostUtil {
  // 当前域名
  static _curHost = ChangeHostConfig.defaultHost
  static get curHost() {
    return this._curHost
  }

  // 获取上一次是否使用备用域名
  static isUseBackupHostHistory() {
    const tmp = localStorage.getItem(ChangeHostConfig.isUseBackupHostKey)
    // 如果本地记录不存在，或者记录值为false
    if (!tmp || !JSON.parse(tmp)) {
      return false
    } else {
      return true
    }
  }

  // 记录是否使用备用域名
  static recordIsUseBackupHost() {
    localStorage.setItem(
      ChangeHostConfig.isUseBackupHostKey,
      JSON.stringify(this.curHost !== ChangeHostConfig.defaultHost)
    )
  }

  // 初始化
  static init() {
    // 读取缓存中备用域名信息
    BackupHostManage.getData()
    // 备用域名信息
    // 1.是否为空
    // 2.保存时间是否超过10m
    if (BackupHostManage.isHostListEmpty || BackupHostManage.isRecordTimeOut) {
      this.resetHost()
    } else {
      // 获取上一次是否使用备用域名
      if (this.isUseBackupHostHistory()) {
        this.switchHost(BackupHostManage.currentHost || ChangeHostConfig.defaultHost)
      } else {
        this.resetHost()
      }
    }
    console.log('当前使用域名(init)：', this.curHost)
  }

  // 检查
  static check() {
    // 读取缓存中备用域名信息
    BackupHostManage.getData()
    // 备用域名信息
    // 1.是否为空
    // 2.保存时间是否超过10m
    if (BackupHostManage.isHostListEmpty || BackupHostManage.isRecordTimeOut) {
      this.resetHost()
    } else {
      if (this.isUseBackupHostHistory()) {
        // 上次是使用备用域名，才进行移除切换
        // 上次使用主域名，直接跳过切换，使用备用域名第一个
        BackupHostManage.changeNext()
      }
      this.switchHost(BackupHostManage.currentHost || ChangeHostConfig.defaultHost)
    }
    console.log('当前使用域名：', this.curHost)
  }

  // 切换域名
  static switchHost(hostUrl) {
    this._curHost = hostUrl
    // 记录是否使用备用域名
    this.recordIsUseBackupHost()
  }

  // 重置域名（主域名）
  static resetHost() {
    // 1.当前域名切换为主域名
    this.switchHost(ChangeHostConfig.defaultHost)
    // 2.清除备用域名信息
    BackupHostManage.cleanData()
    // 3.请求获取备用域名
    BackupHostManage.reqData()
  }

  // 处理响应体，或响应异常
  static handleReqResOrErr(data) {
    const limitHandle = () => {
      if (data.setHostFunc) {
        // 执行域名切换逻辑
        this.check()
        // axios设置baseURL
        data.setHostFunc(this.curHost)
        // 清除异常次数
        HostErrManage.cleanCount()
      }
    }
    // console.log(data)
    // 处理响应体
    if (data.res) {
      HostErrManage.handleRes(data.res, limitHandle)
    }
    // 处理响应异常
    if (data.err) {
      HostErrManage.handleErr(data.err, limitHandle)
    }
  }
}

export { ChangeHostConfig, BackupHostManage, HostErrManage, ChangeHostUtil }
